import React, { Component } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudDownloadAlt, faSearch } from "@fortawesome/free-solid-svg-icons";
import axios from 'axios';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Select from 'react-select';
import './ActivityReportsModule.css';
import { connect } from 'react-redux';
import { css } from "@emotion/core";
import FadeLoader from "react-spinners/FadeLoader";
import ReactTooltip from "react-tooltip";
import fileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const override = css`
  display: block;
  top:50%;
  margin: 0 auto;
  border-color: red;
`;
class ActivityReportsModule extends Component {
    constructor(props) {
        super(props)

        var curr = new Date();
        curr.setDate(curr.getDate());
        var todaydate = curr.toISOString().substr(0, 10);

        this.state = {
            loading: false,
            orderList: [],
            salesmanList: [],
            selectedsalesmanList: [],
            reportList: [],
            orgreportList: [],
            reSalesmanCode: '',
            orderObj: '',
            startDate: todaydate,
            endDate: todaydate,
            smanCode: '',
            todaydate: todaydate,
            httpURL: this.props.httpURL,
            loginuserObj: this.props.userObj,
            distributorCode: this.props.userObj.distributorCode,
            salesmanCode: this.props.userObj.salesmanCode,
            companyCode: this.props.userObj.companyCode,
            userType: this.props.userObj.userType,
            loginSalesmanCode: this.props.userObj.salesmanCode,
            rmOrderTypeFilter: '',
            rmOrderTypeList: [],
            dsrState: '',
            dsrStateList: [],
        }
    }

    componentDidMount() {
        this.getAllSalesmans();
    }

    loadReport() {
        let scode = this.state.salesmanCode;
        if (this.state.loginuserObj.userType === "salesman") {
            scode = scode;
        } else {
            scode = 'All';
        }
        this.setState({
            reSalesmanCode: scode,
            smanCode: scode
        }, () => {
            this.getAllSalesmans();
        });

    }

    getAllSalesmans() {

        let scode = this.state.salesmanCode;
        if (this.state.loginuserObj.userType === "salesman") {
            scode = scode;
        } else {
            // scode = 'All';
            scode = scode;
        }

        const params = {
            salesmanCode: scode,
            companyCode: this.state.companyCode,
        }
        this.setState({
            loading: true
        })
        axios.get(this.state.httpURL + "/report/getSalesmanList", { params })
            .then(response => response.data)
            .then((data) => {
                // console.log(data)
                this.setState({
                    loading: false
                })
                this.setState({
                    salesmanList: data.salesmansList,
                    dsrStateList: data.stateList,
                }, () => {

                    if (data.salesmansList.length === 1) {
                        var temparry = []
                        temparry.push({
                            label: data.salesmansList[0].label,
                            value: data.salesmansList[0].value
                        });

                        this.setState({
                            selectedsalesmanList: temparry
                        })
                    }

                })
            }).catch(err => {
                this.setState({
                    loading: false
                })
                alert(err);
            })
    }

    loadSalesmanList() {
        var dList = this.state.salesmanList;
        var sman = this.state.reSalesmanCode;
        dList.map(function (sales, i) {

            if (sales.salesmanCode === sman) {
                //this.setState({ salesmanList: dList[i] })
            } else {
                dList.splice(i, 1)
            }

        });
        this.setState({ salesmanList: dList })
    }

    reportGo = () => {
        var dFlag = true;
        let stateVal = '';
        if (this.state.startDate !== '' && this.state.endDate !== '') {
            if (this.state.startDate > this.state.endDate) {
                alert("From Date Cannot Be Greater Than End Date");
                dFlag = false;
            }
        } else {
            alert("Please select From and To Date...");
            dFlag = false;
        }

        if (this.state.dsrState === '' || this.state.dsrState === undefined) {
            stateVal = "All";
        } else {
            stateVal = this.state.dsrState;
        }

        if (dFlag) {
            let salesmnallist = "";
            salesmnallist += "'" + this.state.reSalesmanCode + "'"
            let tempSalesmanCode = this.state.reSalesmanCode;
            if (tempSalesmanCode === "" || tempSalesmanCode === null || tempSalesmanCode === undefined) {
                tempSalesmanCode = this.state.loginSalesmanCode;
            } else {
                tempSalesmanCode = this.state.reSalesmanCode;
            }
            const params = {
                salesmanCode: tempSalesmanCode,
                startDate: this.state.startDate,
                endDate: this.state.endDate,
                loginSalesmanCode: this.state.loginSalesmanCode,
                companyCode: this.state.companyCode,
            }

            this.setState({
                loading: true
            })
            axios.get(this.state.httpURL + "/report/getActivityReport", { params })
                .then(response => response.data)
                .then((data) => {
                    if (data.valid) {
                        this.setState({
                            loading: false
                        })
                        this.setState({
                            reportList: data.reportList,
                            orgreportList: data.reportList,
                        })
                        ReactTooltip.rebuild();
                    } else {
                        alert(data.responseMsg);
                    }
                }).catch(err => {
                    this.setState({
                        loading: false
                    })
                    alert(err);
                })
        }
    }

    reportChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleSalesmanChange = (event) => {
        // this.setState({
        //     salesmanCode: event.value
        // });
        this.setState({
            selectedsalesmanList: event,
            reSalesmanCode: event.value
        });
    }

    handleRMOrderTypeFilter = (event) => {
        this.setState({
            rmOrderTypeFilter: event.label
        }, () => {

        });
    }

    handleDSRStateChange = (event) => {
        this.setState({
            dsrState: event.value,
        }, () => {
            this.reportGo();
        });
    }

    filterList = (event) => {
        let filtered = this.state.orgreportList;
        let inputFields = document.getElementsByClassName('maingrid');
        for (var i = 0; i < inputFields.length; i++) {
            if (inputFields[i].value !== '') {
                var searchString = inputFields[i].value;
                var fieldName = inputFields[i].name; //list object column name

                filtered = filtered.filter(od => (
                    od[fieldName].toLocaleString().toLowerCase().search(searchString.toLowerCase()) !== -1
                ));
            }
        }
        this.setState({
            reportList: filtered
        })
    }

    dsrExcel = () => {
        var dFlag = true;
        if (this.state.reportList.length === 0) {
            alert("No Records");
            dFlag = false;
        }
        if (dFlag) {
            var arr = {};
            var arrayList = [];
            var dList = this.state.reportList;
            var fileName = "Activity Report_" + this.state.todaydate;
            var wscols = [
                { wch: 30 },
                { wch: 10 },
                { wch: 20 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 15 },
                { wch: 25 },
            ];
            for (var i = 0; i < dList.length; i++) {
                arr = {};
                arr = {
                    "Sales Person": dList[i].salesmanName,
                    "Emp Id": dList[i].salesmanCode,
                    "Activity Name": dList[i].reason,
                    "Date": dList[i].date,
                    "Task Start Time": dList[i].timeIn,
                    "Task End Time": dList[i].timeOut,
                    "Task Duration": dList[i].timeSpend,
                    "Comments": dList[i].comments
                }
                arrayList.push(arr);
            }
            const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
            const fileExtension = '.xlsx';
            const ws = XLSX.utils.json_to_sheet(arrayList);
            ws['!cols'] = wscols;
            const wb = { Sheets: { 'Activity Report': ws }, SheetNames: ['Activity Report'] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data = new Blob([excelBuffer], { type: fileType });
            fileSaver.saveAs(data, fileName + fileExtension);
        }
    }

    render() {
        const salesmanSearch = [];

        for (const [index, value] of this.state.salesmanList.entries()) {
            salesmanSearch.push({
                label: value.salesmanName,
                value: value.salesmanCode
            });
        }

        return (
            <div className="O2Container_Wrapper">
                <ReactTooltip />
                <div className="O2Container_Table">
                    <div className="O2Table_Header"><span>ACTIVITY REPORT</span></div>
                    <div className="O2Table_Body">
                        <div className="O2Table_SubContainer Report_subContainer">

                            {/* <div className="O2Content_row">
                                <div className="contentRow_Label">State</div>
                                <div className="contentRow_Value">
                                    <Select options={this.state.dsrStateList} name="dsrState" value={this.state.dsrStateList.filter(({ value }) => value === this.state.dsrState)} placeholder="Choose State" onChange={this.handleDSRStateChange} />
                                </div>
                            </div> */}
                            <div className="O2Content_row">
                                <div className="contentRow_Label">Sales Person</div>
                                <div className="contentRow_Value">
                                    <Select options={this.state.salesmanList} name="reSalesmanCode" placeholder="Choose Sales Person" value={this.state.selectedsalesmanList} onChange={this.handleSalesmanChange} />
                                </div>
                            </div>
                            <div className="O2Content_row">
                                <div className="contentRow_Label">Date From </div>
                                <div className="contentRow_Value">
                                    <input type="date" name="startDate" value={this.state.startDate} onChange={this.reportChange} />
                                </div>
                            </div>
                            <div className="O2Content_row">
                                <div className="contentRow_Label">Date To </div>
                                <div className="contentRow_Value">
                                    <input type="date" name="endDate" value={this.state.endDate} onChange={this.reportChange} />
                                </div>
                            </div>
                            <div className="O2Table_Go" onClick={this.reportGo}><button>Go</button></div>
                        </div>

                        <div className="Table_wrapper">
                            <table className="customTable" id="salesmanDSRReport_Table">
                                <thead>
                                    <tr>
                                        <th className="Salesman_width">Sales Person
                                            <div className="searchWrapper">
                                                <FontAwesomeIcon className="SearchIcon" icon={faSearch} style={{ padding: '0px 4px' }} />
                                                <input type="text" className="tableMultiFilterSearch_input maingrid" name="salesmanName" onChange={this.filterList} />
                                            </div>
                                        </th>
                                        <th className="EmpId_width">Employee Id
                                            <div className="searchWrapper">
                                                <FontAwesomeIcon className="SearchIcon" icon={faSearch} style={{ padding: '0px 4px' }} />
                                                <input type="text" className="tableMultiFilterSearch_input maingrid" name="salesmanCode" onChange={this.filterList} />
                                            </div>
                                        </th>
                                        <th className="activity">Activity
                                            <div className="searchWrapper">
                                                <FontAwesomeIcon className="SearchIcon" icon={faSearch} style={{ padding: '0px 4px' }} />
                                                <input type="text" className="tableMultiFilterSearch_input maingrid" name="reason" onChange={this.filterList} />
                                            </div>
                                        </th>
                                        <th className="Time_width">Task Date
                                            <div className="searchWrapper">
                                                <FontAwesomeIcon className="SearchIcon" icon={faSearch} style={{ padding: '0px 4px' }} />
                                                <input type="text" className="tableMultiFilterSearch_input maingrid" name="date" onChange={this.filterList} />
                                            </div>
                                        </th>
                                        <th className="Time_width">Task Start Time
                                            <div className="searchWrapper">
                                                <FontAwesomeIcon className="SearchIcon" icon={faSearch} style={{ padding: '0px 4px' }} />
                                                <input type="text" className="tableMultiFilterSearch_input maingrid" name="timeIn" onChange={this.filterList} />
                                            </div>
                                        </th>
                                        <th className="Time_width">Task End Time
                                            <div className="searchWrapper">
                                                <FontAwesomeIcon className="SearchIcon" icon={faSearch} style={{ padding: '0px 4px' }} />
                                                <input type="text" className="tableMultiFilterSearch_input maingrid" name="timeOut" onChange={this.filterList} />
                                            </div>
                                        </th>
                                        <th className="Time_width">Duration
                                            <div className="searchWrapper">
                                                <FontAwesomeIcon className="SearchIcon" icon={faSearch} style={{ padding: '0px 4px' }} />
                                                <input type="text" className="tableMultiFilterSearch_input maingrid" name="timeSpend" onChange={this.filterList} />
                                            </div>
                                        </th>
                                        <th className="comments_width">Comments
                                            <div className="searchWrapper">
                                                <FontAwesomeIcon className="SearchIcon" icon={faSearch} style={{ padding: '0px 4px' }} />
                                                <input type="text" className="tableMultiFilterSearch_input maingrid" name="comments" onChange={this.filterList} />
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        !this.state.reportList || this.state.reportList === null || this.state.reportList.length === 0 ?
                                            <tr align="center">
                                                <td colSpan="6">No Records</td>
                                            </tr> :
                                            this.state.reportList.map((report) => (
                                                <tr>
                                                    <td className="Salesman_width" data-tip={report.salesmanName}>{report.salesmanName}</td>
                                                    <td className="EmpId_width" data-tip={report.salesmanCode}>{report.salesmanCode}</td>
                                                    <td className="activity" data-tip={report.reason}>{report.reason}</td>
                                                    <td className="Time_width" data-tip={report.date}>{report.date}</td>
                                                    <td className="Time_width" data-tip={report.timeIn}>{report.timeIn}</td>
                                                    <td className="Time_width" data-tip={report.timeOut}>{report.timeOut}</td>
                                                    <td className="Time_width" data-tip={report.timeSpend}>{report.timeSpend}</td>
                                                    <td className="comments_width" data-tip={report.comments}>{report.comments}</td>
                                                </tr>
                                            ))
                                    }

                                </tbody>
                            </table>
                        </div>
                        <div className="O2Table_bottomSubContainer">
                            <div className="O2Table_PageCount"><span className="pageCalc_container">Showing<span> {this.state.reportList ? this.state.reportList.length : 0}</span>entries</span></div>
                        </div>
                        <div className="O2Table_bottomSubContainer">
                            <div className="O2Table_ExpExcel" onClick={() => this.dsrExcel()}><FontAwesomeIcon icon={faCloudDownloadAlt} style={{ padding: '0px 8px' }} />Excel Export</div>
                        </div>
                    </div>
                </div>
                <FadeLoader
                    css={override}
                    size={150}
                    color={"#123abc"}
                    loading={this.state.loading}
                />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        userObj: state.userObj,
        httpURL: state.httpURL
    }
}

export default connect(mapStateToProps)(ActivityReportsModule)